<div class="row">
  <!-- regexValidation -->
  <div *ngIf="isShowRegex" [ngClass]="fieldsClass">
    <div>
      <div
        class="tw-justify-start tw-items-center tw-text-gray-700 dark:tw-text-gray-300 tw-mb-3 tw-font-medium text-info alert-info alert"
        [innerHtml]="'messages.patternFieldHint' | translate"
      ></div>
    </div>
    <form-field
      [(value)]="model.regexValidation"
      [control]="form?.get('regexValidation')"
      [label]="fields + 'regexValidation'"
      (valueChange)="emitModel()"
    >
    </form-field>
  </div>

  <!-- maxFileSizeByMegabyte -->
  <div *ngIf="isShowMaxFileSizeByMegabyte" [ngClass]="fieldsClass">
    <form-field
      [(value)]="model.maxFileSizeByMegabyte"
      type="number"
      [control]="form?.get('maxFileSizeByMegabyte')"
      [label]="fields + 'maxFileSizeByMegabyte'"
      (valueChange)="emitModel()"
    >
    </form-field>
  </div>

  <!-- minValue -->
  <div *ngIf="isShowMinValue" [ngClass]="fieldsClass">
    <form-field
      [(value)]="model.minValue"
      [control]="form?.get('minValue')"
      [label]="fields + 'minValue'"
      (valueChange)="emitModel()"
    >
    </form-field>
  </div>

  <!-- maxValue -->
  <div *ngIf="isShowMaxValue" [ngClass]="fieldsClass">
    <form-field
      [(value)]="model.maxValue"
      [control]="form?.get('maxValue')"
      [label]="fields + 'maxValue'"
      (valueChange)="emitModel()"
    >
    </form-field>
  </div>

  <!--min max date picker-->
  <div
    *ngIf="isShowDateTimeMinValue || isShowDateTimeMaxValue"
    class="!tw-w-1/2"
  >
    <app-periodic-date-picker
      class="row"
      [config]="periodicDateConfig"
      (startDate)="model.dateTimeMinValue = $event; emitModel()"
      (endDate)="model.dateTimeMaxValue = $event; emitModel()"
    >
    </app-periodic-date-picker>
  </div>
  <!-- minLength -->
  <div *ngIf="isShowMinLength" [ngClass]="fieldsClass">
    <form-field
      [(value)]="model.minLength"
      type="number"
      [control]="form?.get('minLength')"
      [label]="fields + 'minLength'"
      (valueChange)="emitModel()"
    >
    </form-field>
  </div>

  <!-- maxLength -->
  <div *ngIf="isShowMaxLength" [ngClass]="fieldsClass">
    <form-field
      [(value)]="model.maxLength"
      type="number"
      [control]="form?.get('maxLength')"
      [label]="fields + 'maxLength'"
      [min]="0"
      (valueChange)="emitModel()"
    >
    </form-field>
  </div>
</div>
